import { render, staticRenderFns } from "./KidCategorySubcategories.vue?vue&type=template&id=46f88991&scoped=true"
import script from "./KidCategorySubcategories.vue?vue&type=script&lang=js"
export * from "./KidCategorySubcategories.vue?vue&type=script&lang=js"
import style0 from "./KidCategorySubcategories.vue?vue&type=style&index=0&id=46f88991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f88991",
  null
  
)

export default component.exports